angular.module('TetherApp').controller('ListCreateController', [
    '$scope',
    '$window',
    'listService',
    'campaignService',
    function (
        $scope,
        $window,
        listService,
        campaignService
    ) {
        let self = this;

        self.campaigns = [];
        self.campaignList = [];
        self.list = {};
        self.list.name = '';
        self.list.campaign_ids = [];
        self.list.allow_multiple = false;

        self.fetchCampaigns = function () {
            campaignService.list().then(onCampaignList, onError);
        };

        let onCampaignList = function (data) {
            self.campaigns = data;
        };

        self.addCampaign = function () {
            let index = -1;
            self.campaignList.forEach(function (campaign, i) {
                if (campaign.id === self.currentCampaign.id) {
                    index = i;
                }
            });
            // Check if campaign has already been added, if not add it
            if (index === -1) {
                self.campaignList.push(self.currentCampaign);
            }
        };

        self.removeCampaign = function (campaign) {
            let index = self.campaignList.indexOf(campaign);
            // Check if campaign exist and remove it
            if (index > -1) {
                self.campaignList.splice(index, 1);
            }
        };

        self.createList = function(callback1, callback2, callback3) {
            if (self.list.name !== undefined && self.list.name !== '') {
                self.campaignList.forEach(function (campaign) {
                    self.list.campaign_ids.push(campaign.id);
                });
                self.onCreateCallback1 = callback1;
                self.onCreateCallback2 = callback2;
                self.onCreateCallback3 = callback3;
                listService.createList(
                    self.list
                ).then(onCreate, onError);
            } else {
                self.errors = {};
                self.errors['name'] = ['The name field is required.'];
            }
        };

        let onCreate = function (data) {
            self.onCreateCallback1();
            if (self.onCreateCallback2 !== undefined) {
                self.onCreateCallback2();
            }
            if (self.onCreateCallback3 !== undefined) {
                self.onCreateCallback3();
            }
        };

        let onError = function(reason) {
            if (reason.data.hasOwnProperty('errors')) {
                self.errors = reason.data.errors;
            }
        };

        $scope.cancel = function() {
            $scope.$parent.cancel();
        };
    }
]);
